import ReactSelect from "react-select";
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var ReactTooltip = require("react-tooltip");

var CurrentUser = require("lib/account/CurrentUser");
var GradeLevel = require("lib/academic/GradeLevel");
var WhooosReadingServices = require("lib/web/WhooosReadingServices")
var AutograderFeedback = require("lib/web/AutograderFeedback");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");
var SurveyPromptConfig = require("lib/survey/SurveyPromptConfig.js");
var SurveyPromptDisplay = require("components/survey/SurveyPromptDisplay.js")
var TextAreaMarkups = require("components/writing/evaluations/TextAreaMarkups");

var DataActions = require("lib/actions/DataActions");
var DataSelectors = require("lib/selectors/DataSelectors");
var GradeLevelSpecifications = require("lib/academic/GradeLevelSpecifications");

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var Spinner = require("components/utility/Spinner");

var AnswerLengthMeter = require("components/writing/answers/AnswerLengthMeter");
var QuestionFeedback = require("components/writing/questions/QuestionFeedback");
var BookCover = require("components/reading/books/BookCover");

require("writing/evaluations/autograder_demo.scss");

@connect(
  (state, props) => ({
    prompt: DataSelectors.surveyPrompt({ state, conditions: { key: 'improve_autograder_and_rubric' } })
  }),

  (dispatch, props) => ({
    populateData: () => {
      return dispatch(DataActions.fetchSurveyPrompts({ conditions: { key: 'improve_autograder_and_rubric' } }))
    },
  })
)

@providePopulateData({ waitForLoad: true })
class AutograderDemo extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-modal")) {
      $(window.document).trigger("onboarding-trigger-autograder-demo");
    }

    this.state = {
      book: null, question: this.defaultQuestion(), showQuestionSelector: false,
      answer: {}, feedbackLoading: false, hideFeedback: false,
      lastSubmittedText: null, feedbackOverridden: false, overriddenTriggers: [],
      gradeEvals: [], showSurveyPrompt: true
    };
  }

  //////////////////////////////////////////
  // Helpers //////////////////////////////
  //////////////////////////////////////////
  defaultQuestion() {
    return QUESTION_OPTIONS[0]
  }

  getAcademicLevel() {
    return CurrentUser.get().prefs && CurrentUser.get().prefs.academic_level ? CurrentUser.get().prefs.academic_level : 3
  }

  idLoading() {
    return this.state.feedbackLoading
  }

  answerParts() {
    return this.state.answer.parts
  }

  answerBodyText() {
    return this.refs.textarea ? this.refs.textarea.value : ''
  }

  // Check to see if a particular filter was detected.
  hasFilter(filter, autograderData) {
    if (autograderData && autograderData.filtering) {
      var filters = _.keys(autograderData.filtering);
      return filters.includes(filter);
    } else {
      return false;
    }
  }

  // extract polorizing hash from evaluation
  polarizingHashes() {
    var { gradeEvals } = this.state
    return _.map(_.pluck(gradeEvals, 'polarizing'), layer => { return AutograderDisplayConfig.getRubricLeaves(layer, true) })
  }

  labelValue(val) {
    var val = $wr.toTitleCase(val)
    return val in OUTPUT_ABBREV ? OUTPUT_ABBREV[val] : val
  }

  gradeAutograderData() {
    return _.findWhere(this.state.gradeEvals, { grade_level: this.getAcademicLevel() || 3 })
  }

  // determinse the background and font classes for rubric labels
  colorClasses(value) {
    // if value is not a string, return black
    if (!(typeof value == 'string')) {
      return { backgroundClass: 'backgroundColor-black', fontClass: 'fontColor-black' }
    }

    if (_.includes(AutograderDisplayConfig.SUCCESS_OUTPUT, $wr.toTitleCase(value))) {
      var backgroundClass = 'backgroundColor-green'
      var fontClass = 'fontColor-green'
    } else if (_.includes(AutograderDisplayConfig.FAIL_OUTPUT, $wr.toTitleCase(value))) {
      var backgroundClass = 'backgroundColor-red'
      var fontClass = 'fontColor-red'
    } else if (_.includes(AutograderDisplayConfig.MIDDLING_OUTPUT, $wr.toTitleCase(value))) {
      var backgroundClass = 'backgroundColor-yellow'
      var fontClass = 'fontColor-yellow'
    }

    return { backgroundClass, fontClass }
  }

  getBadgeForAGKey(key) {
    if (_.includes(AutograderDisplayConfig.NEW_KEYS, key)) {
      return <span className="badge backgroundColor-dark-green">New!</span>
    } else if (_.includes(AutograderDisplayConfig.BETA_KEYS, key)) {
      return <span className="badge backgroundColor-blue">Beta</span>
    }
  }

  // scrolls to bottom of modal
  scrollToBottom() {
    $('.autograderDemoModal').first().animate({ scrollTop: $(".autograderDemoModal").first().height() }, 'slow');
  }

  //////////////////////////////////////////
  // Feedback //////////////////////////////
  //////////////////////////////////////////

  feedbackSubs() {
    var autograderData = this.gradeAutograderData()
    if (autograderData && autograderData.feedback_subs) {
      return autograderData.feedback_subs;
    }
  }

  feedbackItems() {
    var autograderData = this.gradeAutograderData()
    if (autograderData && autograderData.assisting) {
      var feedbackItems = _.map(autograderData.assisting.selected_content, (content, priority) => {
        if (!content.trigger || !_.includes(this.state.overriddenTriggers, content.trigger)) {
          return content
        }
      })
      return _.compact(feedbackItems)
    }
  }

  showFeedback() {
    return _.any(this.feedbackItems()) && !this.state.hideFeedback && !this.state.feedbackLoading;
  }

  checkAddressedFeedback(newAutograderData) {
    var oldAutograderData = this.gradeAutograderData();
    if (!(oldAutograderData && newAutograderData &&
      oldAutograderData.assisting && newAutograderData.assisting)) {
      return false;
    }

    var previousFeedback = oldAutograderData.assisting.selected_feedback;
    var currentFeedback = newAutograderData.assisting.eligible_feedback;

    if (!currentFeedback.includes(previousFeedback)) {
      return true;
    }
    return false;
  }

  // For feedback, check to see if we should show the coin award option.
  // Don't show if answer is too short to grade properly
  shouldRewardShow() {
    var autograderData = this.gradeAutograderData();

    if (!autograderData) {
      return false;
    }

    // Check if answer is too short
    if (this.hasFilter("REQUIREMENT-MINIMUM_LENGTH", autograderData)) {
      return false;
    }

    return true
  }

  // adds feedback override to metadata
  onFeedbackOverride(data, reason, e) {
    $wr.nope(e)
    this.setState({ feedbackOverridden: true, overriddenTriggers: [...this.state.overriddenTriggers, data.trigger] })
  }

  //////////////////////////////////////////
  // State setters /////////////////////////
  //////////////////////////////////////////
  hideSurveyPrompts() {
    this.setState({ showSurveyPrompt: !this.state.showSurveyPrompt })
  }

  setSelectedText(val) {
    this.setState({ book: val }, this.scrollToBottom )
  }

  showQuestionSelector() {
    this.setState({ showQuestionSelector: true })
  }
  
  // changes question
  onQuestionChange(newQuestion) {
    this.setState({ showQuestionSelector: false, question: _.findWhere(QUESTION_OPTIONS, { key: newQuestion.value }) })
  }
  
  //////////////////////////////////////////
  // Submit methods ////////////////////////
  //////////////////////////////////////////

  submitAnswer() {
    var { book, question } = this.state

    if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) {
      $(window.document).trigger("onboarding-trigger-autograder-demo");
    }
    
    if (_.size(this.answerBodyText()) == 0) {
      var errorText = "Please write at least a short response to this question.";
      window.wrNotifications.triggerDropDownNotification({
        title: "We need a bit more!", icon: "pencil", text: errorText
      });
      return;
    }

    var answerData = {
      answer: this.answerBodyText(),
      answerParts: this.answerParts(),
      starters: [],
      text: book,
      questionKey: question.key,
      questionText: question.body, quiz: true,
      gradeDemo: true
    };

    this.setState({ gradeEvals: [], feedbackLoading: true, lastSubmittedText: this.answerBodyText() })

    var evalPromise = (answerData) => new Promise((resolve, reject) => {
      AutograderFeedback.fetch(answerData, (result) => {
        result && result.autograderData ? resolve(result.autograderData) : resolve(null)
      })
    })

    evalPromise(answerData)
      .then(evals => {
        this.setState({ feedbackLoading: false })
        if (_.any(_.values(evals), (e) => e == null)) {
          window.wrNotifications.triggerDropDownNotification({
            title: "Something went wrong on our end, sorry!",
            text: "This is embarrassing for us... try refreshing the page or trying again later.",
            icon: "exclamation-sign", type: "error"
          }, 6000);
        } else {
          this.setState({ gradeEvals: _.values(evals), feedbackLoading: false }, this.scrollToBottom)
        }
      })
      .catch((error) => {
        this.setState({ feedbackLoading: false })
        console.log(error)
      })
  }

  //////////////////////////////////////////
  // Render methods ////////////////////////
  //////////////////////////////////////////
  renderQuestionDisplay() {
    if (this.state.showQuestionSelector) {
      var options = _.map(QUESTION_OPTIONS, (q) => {
        return { label: q.body, value: q.key }
      })

      var content = <ReactSelect name="demoQuestion" searchable={false} clearable={false}
                    value={{ label: this.state.question.body }} options={options} onChange={this.onQuestionChange.bind(this)} />
    } else {
      var changeQuestionLink = (
        <div className="changeQuestionLink">
          <a href="#" onClick={this.showQuestionSelector}>
            <Glyphicon icon="edit" /> Change Question
          </a>
        </div>
      );

      var content = <span>{this.state.question.body} {changeQuestionLink}</span>
    }

    return (
      <div className="promptText clearfix">
        {content}
      </div>
    );
  }

  renderWritingInterface() {
    return (
      <textarea key={this.state.question.key}
        className="form-control singleAnswer LoNotSensitive" rows="6" ref="textarea"
      />
    )
  }

  renderAnswerLengthMeter() {
    var answerLength = _.size(this.answerBodyText());

    var charCount = GradeLevel.getRecommendedAnswerLength(this.getAcademicLevel());
    var filterCount = GradeLevel.getCharCountFilter(this.getAcademicLevel());

    charCount = Math.max(charCount * 0.8, 20);
    filterCount = Math.max(filterCount, 20);


    return (
      <div id="answerLengthMeter">
        <AnswerLengthMeter currentCharCount={answerLength}
          charCount={charCount} filterCount={filterCount} />
      </div>
    );
  }

  renderButton() {
    var btnText = _.isEmpty(this.state.gradeEvals) ? "Grade Answer" : "Regrade My Answer"
    return (
      <div className="buttons">
        <LoadingButton className="btn buttonPrimary" text={btnText}
          onClick={() => this.submitAnswer()} loading={this.state.feedbackLoading} />
        <ReactTooltip effect="solid" />
      </div>
    )

  }

  renderFeedback() {
    if (this.showFeedback()) {
      var subs = this.feedbackSubs();
      var renderedItems = _.map(this.feedbackItems(), (item) => {
        var feedbackItem = FeedbackFormatter.format(_.first(item.content), subs);
        feedbackItem.data = item
        return feedbackItem
      })
      return (
        <div className="questionFeedbackBox">
          <QuestionFeedback onFeedbackOverride={this.onFeedbackOverride} feedbackItems={renderedItems}
            showFeedbackReward={this.shouldRewardShow()} />
        </div>
      );
    }
  }

  renderStartTrialBtn() {
    var user = CurrentUser.get()
    var trialPath = "/users/" + user.id + "/trigger?what=trial&features=wrSilver&days=30";
    var trialURL = WhooosReadingServices.ApiServer.url(trialPath);

    return <a href={trialURL}>Start your free 30 day trial of Silver</a>
  }

  renderConsultationLink() {
    var linkEventHandler = Mycroft.buildEventHandler({
      category: "Consultation Call", action: "schedule-consultation", label: 'Schedule a Consultation'
    });

    return (
      <span>
        If you are interested in upgrading your account,
        <a href="https://calendly.com/whooos-reading/wrs-consultation" className={"consultationLink"} target="_blank" onClick={linkEventHandler}>schedule a consultation</a>
      </span>
    )
  }

  renderUpgradeLink() {
    if (!CurrentUser.isPremiumOrTrialAccount()) {
      return (
        <div className="upgradeDisclaimer">
          <div className="title">Important note</div>
          <div className="description">
            As a free user, <b>your plan does not include rubric analytics</b>. {this.renderStartTrialBtn()}.
          </div>
        </div>
      )
    }
  }

  // looks up grade level specifications for a rubric item
  gradeLevelSpecificationToolTip(rubricKey) {
    var polarizingKey = AutograderDisplayConfig.POLARIZING_KEY_TO_RUBRIC_KEY[rubricKey]
    var gradeLevelExpectations = GradeLevelSpecifications[polarizingKey][this.getAcademicLevel()] || GradeLevelSpecifications[polarizingKey]['default']
    if (gradeLevelExpectations) {
      return _.map(gradeLevelExpectations, (exp, i) => { 
        var returnVal = exp
        if (i == 0) {
          returnVal = `<span>${returnVal}`
        }
        
        if (_.size(gradeLevelExpectations) - 1 != i) {
          returnVal = `${returnVal}<br/><br/>`
        }
        
        if (_.size(gradeLevelExpectations) - 1 == i) {
          returnVal = `${returnVal}</span>`
        }

        return returnVal
      }).join('')
    }
  }

  renderRubric() {
    var { gradeEvals } = this.state
    if (_.size(gradeEvals) == 9) {
      // grade level headers
      var headerRow = [<th className='longCell' key={'gradeLevel-0'}></th>]
      _.each([...Array(9).keys()], i => {
        if (i == 0) {
          var text = 'K-1'
        } else if (i == 8) {
          var text = 'Grade 9+'
        } else {
          var text = `Grade ${i+1}`
        }

        headerRow.push(<th className='standardCell headerCell' key={`gradeLevel-${i + 1}`}>{text}</th>)
      })

      // rows of labels
      var bodyRows = _.keys(this.polarizingHashes()[0]).map((rubricKey, ridx) => {
        var badge = this.getBadgeForAGKey(rubricKey)
        var cells = [
          <td className={`longCell`} key={`rubricKey-${ridx}`}>
            {AutograderDisplayConfig.getLeafName(rubricKey)}{badge}
          </td>]
        _.each(this.polarizingHashes(), (evaluation, eidx) => {
          if (evaluation[rubricKey].value) {
            var dataTip = this.gradeLevelSpecificationToolTip(rubricKey)
            var { backgroundClass, fontClass } = this.colorClasses(evaluation[rubricKey].value)
            cells.push(
              <td className='standardCell' key={`${rubricKey}-${eidx}`} data-tip={dataTip} data-for={`${rubricKey}-${eidx}`} data-html={true}>
                <div className={`textContainer ${backgroundClass} ${fontClass}`}>{this.labelValue(evaluation[rubricKey].value)}</div>
                <ReactTooltip effect="solid" id={`${rubricKey}-${eidx}`} />
              </td>
            )
          } else {
            cells.push(<td></td>)
          }
        })
        return <tr key={`${rubricKey}-${ridx}`}>{cells}</tr>
      });

      // return table
      return (
        <span>
          {this.renderStep(3)}
          <div className="rubricTableContainer">
            <table className="table table-borderless">
              <thead>
                <tr>
                  {headerRow}
                </tr>
              </thead>
              <tbody>
                {bodyRows}
              </tbody>
            </table>
          </div>
          {this.renderSurveyPrompt()}
          {this.renderUpgradeLink()}
        </span>
      )
    } else if (_.size(gradeEvals)) {
      // render loading
      return <Spinner placeholder={true} scale={1.7} />
    }
  }
  
  // highlighted sections of text evidence
  renderTextEvidenceTags() {
    var autograderData = this.gradeAutograderData()
    if (autograderData && autograderData.polarizing) {
      var polarizingHash = autograderData.polarizing
      if (polarizingHash[TEXT_EVIDENCE_KEY] && !_.isEmpty(polarizingHash[TEXT_EVIDENCE_KEY].tags)) {
        var content = <TextAreaMarkups text={this.state.lastSubmittedText || ''} tagColors={{ 'KNOWN_TEXT_VOCAB': '#c0f2aa', 'KNOWN_TEXT_GROUP': '#96dafe' }}
          tagging={polarizingHash[TEXT_EVIDENCE_KEY].tags} />
      } else {
        var content = "No text evidence detected"
      }

      return (
        <div className="textEvidenceContainer">
          <div className="step">
            <div className="title">Text Evidence Identified</div>
          </div>
          <div className="textEvidenceContent">
            {content}
          </div>
        </div>
      )
    }
  }

  // render text area if book is selected
  renderAnswerWritingInterface() {
    if (this.state.book) {
      var slideClassName = this.showFeedback() ? " slideLeft" : "";

      return (
        <span>
          {this.renderStep(2)}
          <div className="clearfix answerFeedbackContainer">
            <div className={"questionOptionBox" + slideClassName}>
              {this.renderQuestionDisplay()}
              {this.renderWritingInterface()}
              {this.renderAnswerLengthMeter()}
              <div className="controls">
                {this.renderButton()}
              </div>
            </div>
            {this.renderFeedback()}
            <div className="clearfix"></div>
            {this.renderTextEvidenceTags()}
            <div className="clearfix"></div>
            {this.renderRubric()}
          </div>
        </span>
      )
    }
  }

  // renders book option boxes
  renderTextSelector() {
    var options = _.map(BOOK_OPTIONS, bookOp => {
      var className = "largeObject clickableElement";
      if (this.state.book && this.state.book.text_id == bookOp.text_id) {
        className += " selected";
      }

      return (
        <div key={bookOp.text_id} className={className}
          onClick={() => this.setSelectedText(bookOp)}>
          <BookCover book={bookOp} coverWidth={80}
            showTitle={true} showAuthor={false} />
        </div>
      )
    })

    return (
      <span>
        {this.renderStep(1)}
        <div className="bookOptionsContainer">
          {options}
        </div>
      </span>
    )
  }

  renderIntroParagraph() {
    return (
      <div className="intro">
        Our autograder, backed by the National Science Foundation, does three things:
        <div className="list">
          <div>1. Provides <b>in-the-moment feedback for your students</b> to help them revise their answers.</div>
          <div>2. Evaluates and <b>scores every written response</b> your students write about their books.</div>
          <div>3. Gives you data on <b>10+ reading and writing skills</b> based on your students' answers.</div>
        </div>
        <p>Our autograder's detailed rubric shows you exactly what skill your students are mastering and where they need extra support.</p>
        <p>The autograder technology includes built-in differentiation based on your students' Academic Level, so a student at a 2nd grade level has a vastly different feedback and evaluation experience than another at an 8th grade level.</p>
      </div>
    )
  }

  renderStep(stepNum) {
    return (
      <div className="step">
        <div className="title">Step {stepNum}: {STEPS[stepNum]['title']}</div>
        <div className="subtitle">{STEPS[stepNum]['subtitle']}</div>
      </div>
    )
  }

  renderSurveyPrompt() {
    if (this.state.showSurveyPrompt) {
      var prompt = _.extend(SurveyPromptConfig.CONFIG[this.props.prompt.key], this.props.prompt)
      prompt.options = prompt.options.split('|')

      return (
        <div className="surveyPromptContainer contentSurvey twoRows">
          <SurveyPromptDisplay
            onSubmitFeedback={this.hideSurveyPrompts}
            prompt={prompt}
            userID={CurrentUser.get().id}
            />
        </div>
      )
    }
  }

  render() {
    return (
      <div id="autograderDemo" className="autograderDemo">
        {this.renderIntroParagraph()}
        {this.renderTextSelector()}
        {this.renderAnswerWritingInterface()}
      </div>
    )
  }
};

//////////////////////////////////////////
// Constants /////////////////////////////
//////////////////////////////////////////
var BOOK_OPTIONS = [
  {
    title: "The Kid Who Ran for President",
    text_id: "BASEv-ksokC6AqHZMSGcMMlAMQ",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEv-ksokC6AqHZMSGcMMlAMQ.jpg",
    img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1388248991l/134314.jpg",
    lexile_score: 730,
    text_variety: "fiction",
    author_full_name: "Dan Gutman"
  },
  {
    title: "Dog Man",
    text_id: "BASEAOH8j3w9WsZOxNQ9dzAUFQ",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEAOH8j3w9WsZOxNQ9dzAUFQ.jpg",
    img_url: "http://images.gr-assets.com/books/1456963971m/28691896.jpg",
    lexile_score: 390,
    text_variety: "fiction",
    author_full_name: "Dav Pilkey"
  },
  {
    title: "Harry Potter and the Half-Blood Prince",
    text_id: "BASEm63cVUZNZ5HY11ddGWD4lw",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEm63cVUZNZ5HY11ddGWD4lw.jpg",
    img_url: "http://images.gr-assets.com/books/1361039191m/1.jpg",
    lexile_score: 920,
    text_variety: "fiction",
    author_full_name: "J.K. Rowling"
  },
  {
    title: "Diary of a Wimpy Kid",
    text_id: "BASECT2oC2Dz_6QR5EkAW0SaSw",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASECT2oC2Dz_6QR5EkAW0SaSw.jpg",
    img_url: "https://images.gr-assets.com/books/1388183826l/389627.jpg",
    lexile_score: 950,
    text_variety: "fiction",
    author_full_name: "Jeff Kinney"
  },
  {
    title: "Polar Bear vs. Grizzly Bear",
    text_id: "BASEG6VrmMVPWsnfxG_fw2_9jA",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEG6VrmMVPWsnfxG_fw2_9jA.jpg",
    img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1363913976l/9517995.jpg",
    lexile_score: 720,
    text_variety: "non-fiction",
    author_full_name: "Jerry Pallotta"
  },
  {
    title: "To Kill a Mockingbird",
    text_id: "BASEbPUyebgBeNFuLgVhJ5GvkQ",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEbPUyebgBeNFuLgVhJ5GvkQ.jpg",
    img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1553383690l/2657.jpg",
    lexile_score: 790,
    text_variety: "fiction",
    author_full_name: "Harper Lee"
  },
  {
    title: "Sisters",
    text_id: "BASE9S4V0Kl0Hze8FzJi8b4ISA",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASE9S4V0Kl0Hze8FzJi8b4ISA.jpg",
    img_url: "http://images.gr-assets.com/books/1411022689m/18225810.jpg",
    lexile_score: 290,
    text_variety: "fiction",
    author_full_name: "Raina Telgemeier"
  }, 
  {
    title: "Hatchet",
    url: null,
    text_id: "BASEFtxN7k9uV4e6bfT-bZZjNg",
    cover_url: "https://storage.googleapis.com/matilda_book_covers/BASEFtxN7k9uV4e6bfT-bZZjNg.jpg",
    img_url: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1385297074l/50.jpg",
    lexile_score: 1020,
    text_variety: "fiction",
    author_full_name: "Gary Paulsen"
  }
]

var QUESTION_OPTIONS = [
  {
    body: "What made the main character unique?", 
    key: "rl3-key-connections--3--what-made-the-main-character",
  }, 
  { 
    body: "How do you think the main character would solve a future problem in life? Include details from the text to support your thoughts.", 
    key: "rl3-key-connections-how-do-you-think-the-main-char",
  },
  { 
    body: "Would you want to be a part of this story—one of the characters living in this time and place? Explain why or why not.", 
    key: "rl3-key-connections-would-you-want-to-be-a-part-of",
  }, 
  {
    body: "Which character helped the main character the most? Explain how that character helped using details from the text.",
    key: "rl1-key-details-which-character-helped-the-mai"
  },
  {
    body: "How did the central idea develop over the course of the text?",
    key: "ri2-key-main--78--how-did-the-central-idea"
  }
]

var TOOLTIP_LOOKUP = {
  'crit-evi-cote-bert-read-book-1': 'Base on threshold of 2-3 text-specific details'
}

var STEPS = {
  1: { title: 'Select a book', subtitle: "The Whooo's Reading library of texts is not restrictive. There are standards-aligned quizzes available for any title students read. Here is a small sample of our most popular books:" },
  2: { title: 'Write a response', subtitle: 'Click "Change Question" to choose from a small sample of our quiz questions. Then write a response and see how students receive in-the-moment feedback from Owlfonso.'},
  3: { title: 'Analyze rubric results', subtitle: "With each open-ended quiz question and practice question students write, teachers can analyze the scoring rubric to find where students are excelling and struggling. Evaluations vary by grade level to ensure that students are being graded appropriately." },
}

var TEXT_EVIDENCE_KEY = 'crit-evi-cote-bert-quantity-14'

var OUTPUT_ABBREV = {
  'Sufficient': 'Suf',
  'Insufficient': 'Insuf',
  'Incorrect': 'Incor',
  'Developing': 'Dev'
}

module.exports = AutograderDemo;



// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/AutograderDemo.js